import { render, staticRenderFns } from "./official.vue?vue&type=template&id=0f7b89f6&"
import script from "./official.vue?vue&type=script&lang=ts&"
export * from "./official.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports